module.exports = __webpack_public_path__ + "static/img/miles_pictgrid4_980x874.5470f74.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/miles_pictgrid4_980x874.jpg
// module id = 2d2m
// module chunks = 0